import FormUser from './FormUser';
import FormTest from './FormTest';
import FormDocument from './FormDocument';

import FormTestQuestion from './TestQuestion';
import FormTestSettings from './TestSettings';
import FormLesson from './Lesson';
import FormCategory from './Category';
import FormPresentation from './Presentation';
import FormResourceAccess from './ResourceAccess';

export default {
  FormUser,
  FormTest,
  FormTestQuestion,
  FormTestSettings,
  FormLesson,
  FormCategory,
  FormPresentation,
  FormResourceAccess,
  FormDocument,
};
